const actions = {
    SETTEAMSTOKEN: 'SETTEAMSTOKEN',
    SETAPITOKEN: 'SETAPITOKEN',
};

export default actions;